<template>
    <div class="voucherList">
        <div class="headTopRow">
            <year-picker @yearChange="yearChange($event)" :year="year"></year-picker>
        </div>
        <van-row class="pannal" gutter="10">
            <van-col span="12" v-for="(voucher,index) in voucherList" :key="index">
                <div
                    v-if="voucher.data && voucher.data.length>0"
                    class="voucher"
                    @click="checkVoucher(year + '-' + (index<9 ? ('0' + (index+1)) : (index+1)))"
                >
                    <i class="iconfont icon-confirm_order fs24"></i>
                    <span class="year">{{year}}年</span>
                    <span>第{{index+1}}期</span>
                </div>
                <div v-else class="voucher novoucher">
                    <i class="iconfont icon-confirm_order fs24"></i>
                    <span class="year">{{year}}年</span>
                    <span>第{{index+1}}期</span>
                </div>
            </van-col>
        </van-row>
    </div>
</template>

<script>
import Vue from "vue";
import YearPicker from "@/components/YearPicker.vue";
import { Popup, Row, Col, Toast } from "vant";
Vue.use(Popup)
  .use(Row)
  .use(Col)
  .use(Toast);
export default {
  name: "voucherList",
  components: {
    YearPicker
  },
  data() {
    return {
      companyId: '',
      voucherList: [],
      year: this.$route.query.year || new Date().getFullYear(),
      months: [
        "01",
        "02",
        "03",
        "04",
        "05",
        "06",
        "07",
        "08",
        "09",
        "10",
        "11",
        "12"
      ],
      fromAcctCustomerInfo:this.$store.state.fromAcctCustomerInfo,
    };
  },
  methods: {
    yearChange(e) {
      this.year = e;
      this.getVoucherList(e);
    },
    checkVoucher(yearPeriod) {
      this.$router.push({
        name: "voucherDetail",
        query: { yearPeriod: yearPeriod }
      });
    },
    getVoucherList(year) {
      let _this = this;
      this.voucherList = [];
      //递归算法，防止数组顺序错乱
      getVoucher(0, _this.months.length);
      function getVoucher(j, length) {
        let month = _this.months[j];
        let url = Object.keys(_this.fromAcctCustomerInfo).length > 0 ? ("/fc/voucher/small?companyId=" +_this.fromAcctCustomerInfo.companyId + "&period=" + year + "-" + month + '&dbId=' +_this.fromAcctCustomerInfo.databaseId) : ("/fc/voucher/small?companyId=" +_this.companyId + "&period=" + year + "-" + month)
        _this.$http
          .get(url)
          .then(function(res) {
            if (res.data.code == 200) {
              let goodsList = res.data;
              goodsList.sn = j;
              _this.voucherList.push(goodsList);
              _this.voucherList.sort((a, b) => {
                return a.sn - b.sn;
              });
              if (++j < length) {
                getVoucher(j, length);
              }
            } else {
              Toast(res.data.msg);
            }
          })
          .catch(error => {
            Toast(error);
          });
      }
      console.log(this.voucherList, "this.voucherList");
    }
  },
  mounted() {
    this.companyId = this.$store.state.companyInfo && this.$store.state.companyInfo.companyID;
    this.getVoucherList(this.year);
  }
};
</script>
<style lang="stylus" scoped>
.headTopRow {
    background-color: #ffffff;
    padding: 0 0 0.08rem 0;
}

.pannal {
    padding: 0.12rem;

    .voucher {
        padding: 0.12rem;
        border-radius: 0.04rem;
        border: 1px solid rgba(221, 227, 233, 1);
        background-color: #ffffff;
        margin-bottom: 0.12rem;

        .icon-confirm_order {
            color: #1fadf6;
            vertical-align: top;
            position: relative;
            top: 0.02rem;
        }

        .year {
            margin: 0 0.08rem 0 0.12rem;
            line-height: 0.2rem;
        }
    }

    .voucher.novoucher {
        color: #8896A4;

        .icon-confirm_order {
            color: #8896A4;
        }
    }
}
</style>

